export default "__VITE_ASSET__CM9pHTZv__"